(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityFieldList', drvEntityFieldList);

    drvEntityFieldList.$inject = [];
    EntityFieldListCtrl.$inject = ['$scope', 'DialogService', 'EntityDialogService'];

    function drvEntityFieldList() {
        return {
            templateUrl: 'app/entity-field-list.tmpl.html',
            controller: EntityFieldListCtrl
        };
    }

    function EntityFieldListCtrl($scope, DialogService, EntityDialogService) {
        var vm = $scope.vm;
        vm.addLinkedEntity = addLinkedEntity;
        vm.deleteEntityLink = deleteEntityLink;
        vm.findEntityTemplate = findEntityTemplate;
        vm.findFieldType = findFieldType;
        vm.getVisibleTemplateFields = getVisibleTemplateFields;

        vm.entityCache = null;
        Object.defineProperty(vm, 'theEntity', {
            get: function () {
                if (vm.entityCache === null) {
                    if (angular.isDefined(vm.entity) && vm.entity !== null && angular.isDefined(vm.entityTemplates) && vm.entityTemplates !== null && vm.entityTemplates.length > 0 &&
                    angular.isDefined(vm.fieldTypes) && vm.fieldTypes !== null && vm.fieldTypes.length > 0) {
                        vm.entityCache = vm.entity;
                    }

                    return vm.entityCache;
                } else {
                    return vm.entityCache;
                }
            }
        });

        /**
         * Show a dialog to select entities which can be linked.
         */
        function addLinkedEntity(templateField) {
            var entityTemplate = vm.findEntityTemplate(templateField.EntityTemplateId);
            var pageHeading = 'Select ' + entityTemplate.Name;

            DialogService.show({
                locals: { pageHeading: pageHeading, entityTemplate: entityTemplate, multiSelectMode: false, usersForEntityTemplate: false, loadUserEntities: false },
                controller: 'EntitySelectorDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/controls/entity/entity-selector-dialog.tmpl.html',
                size: DialogService.sizes.extraLarge
            })
            .then(editFieldOk);

            function editFieldOk(entityIds) {
                vm.entity.Fields[templateField.Name] = entityIds[0];
            }
        }

        /**
         * Delete the supplied entity link for the specified field.
         */
        function deleteEntityLink(field, linkedEntityId) {
            var entityTemplate = findEntityTemplate(field.EntityTemplateId);

            EntityDialogService.confirmDeleteEntities(linkedEntityId, entityTemplate)
                .then(function () {
                    vm.entity.Fields[field.Name]= null;
                });
        }

        function findEntityTemplate(templateId)
        {
            return _.find(vm.entityTemplates, function (n) { return n.Id == templateId; });
        }

        /**
         * @param {string} fieldType
         * @return {object}
         */
        function findFieldType(fieldType)
        {
            return _.find(vm.fieldTypes, function (n) { return n.Name == fieldType; });
        }

        function getVisibleTemplateFields() {
            var result = [];

            if (!angular.isUndefined(vm.entity) && vm.entity !== null && !angular.isUndefined(vm.entity.EntityTemplate) && vm.entity.EntityTemplate !== null &&
            !angular.isUndefined(vm.entityTemplates) && vm.entityTemplates !== null && vm.entityTemplates.length > 0) {
                if (vm.theEntity !== null && vm.theEntity.EntityTemplate !== null) {
                    result = _.filter(vm.theEntity.EntityTemplate.Fields, function (templateField) { return templateField.Visible; });
                }
            }

            return result;
        }
    }
})();